import LayoutSouvenir from "@/layouts/souvenir/layout-souvenir.vue"
import oPolaroid from "@/objects/o-polaroid/o-polaroid.vue"

export default {
  name: "vSouvenir",
  components: {
    "layout-souvenir": LayoutSouvenir,
    "o-polaroid": oPolaroid
  },
  data() {
    return {}
  },
  computed: {
    src() {
      return process.env.VUE_APP_CLOUDINARY_BASE_URL + this.$route.params.folder_id + '/inventions/' + this.$route.params.image_id + '.png';
    }
  }
}
